module.exports = __webpack_public_path__ + "static/media/payment-show.9483ba07.png";